import React, { useState } from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import Swal from 'sweetalert2';

import ApiService from '../../helpers/ApiService';
import { useAuth } from '../../providers/AuthProvider';
import { CTA } from '../Common/CTA';

const ChangePasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: center;

  main {
    background-color: var(--primary);
    padding: 1.5rem;
    border-radius: 1rem;
    width: 100%;
    max-width: 720px;

    @media screen and (max-width: 600px) {
      width: 82%;
    }
  }

  form {
    .MuiInputBase-root {
      color: var(--bluegray-600);
      background-color: var(--white);
    }
    
    .MuiFormHelperText-root {
      color: var(--white);
    }
    .MuiFormControlLabel-label  {
      color: var(--white);
    }
  }
`;

export const FormChangePassword = (props) => {
  const { token } = useAuth();
  const { register, handleSubmit, formState: {errors}, setError, clearErrors, setValue, getValues } = useForm();
  const [ isLoading, setIsLoading ] = useState(true);

  const closeModal = (e) => {
    if(e.target.id === "modalContainer") props.onClose();
  }

  const setConfirmPassword = (e) => {
    setValue("confirmPassword", e.target.value);
    checkPass();
  }

  const checkPass = () => {
    if ( getValues("confirmPassword") !== getValues("newPassword") ) {
      setError("confirmPassword");
      return false;
    }
    else {
      clearErrors("confirmPassword");
      return true;
    }
  }

  const onSave = async data => {
    if(checkPass()) {
      setIsLoading(true);
      delete data.confirmPassword;
      ApiService.put('user/update', data, token).then( (result) => {
        if( result.status === 200) {
          Swal.fire({
            title: `Beleza!`,
            text: 'Sua nova senha foi atualizada com sucesso!',
            icon: 'success',
            confirmButtonText: 'Obrigado'
          });
          setValue("password", "");
          setValue("newPassword", "");
          setValue("confirmPassword", "");

          props.onClose();
        }
      }).catch((error) => {
        if ( error.status === 400 ) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.data,
            confirmButtonText: "Entendi"
          });
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Ocorreu um erro desconhecido. Tente novamente mais tarde.',
            confirmButtonText: "Entendi"
          });
        }
      });
    }
  }
  return (
    <ChangePasswordContainer id="modalContainer" onClick={closeModal}>
      <main>
        <Typography variant="h6" align="center" className='white--text' mb={1}>
          Alterar senha
        </Typography>
        <form onSubmit={handleSubmit(onSave)}>
          <Grid container spacing={2}>
            <Grid item sm={12} xs={12}>
              <Typography variant="caption" className="white--text bold-text opacity" gutterBottom>
                Senha atual
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                placeholder="Sua senha atual"
                name="password"
                type="password"
                {...register('password', { required: true, minLength: 6 })}
                error={!!errors.password}
                helperText={errors.password && "Senha deve conter pelo menos 6 caracteres"}
                onChange={() => isLoading && setIsLoading(false)}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Typography variant="caption" className="white--text bold-text opacity" gutterBottom>
                Nova senha
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                placeholder="Nova senha"
                name="newPassword"
                type="password"
                {...register('newPassword', { required: true, minLength: 6 })}
                error={!!errors.newPassword}
                helperText={errors.newPassword && "Senha deve conter pelo menos 6 caracteres"}
                onChange={() => isLoading && setIsLoading(false)}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Typography variant="caption" className="white--text bold-text opacity" gutterBottom>
                Confirmar nova senha
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                placeholder="Confirmar nova senha"
                name="confirmPassword"
                type="password"
                {...register('confirmPassword', { required: true, minLength: 6 })}
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword && "Senha deve ser igual a sua nova senha"}
                onChange={setConfirmPassword}
              />
            </Grid>
            <Grid item sm={12} xs={12} align="center">
              <CTA type="submit" disabled={isLoading} >
                Alterar senha
              </CTA>
            </Grid>
          </Grid>
        </form>
      </main>
    </ChangePasswordContainer>
  )
}